import React, { useState, useCallback, useMemo } from 'react'
import { observer } from 'mobx-react'
import makeStyles from '@mui/styles/makeStyles'
import Button from '@mui/material/Button'

import { useStores, useApiRequest } from 'admin/hooks'
import * as srv from 'admin/services'

import InfoSection from 'admin/components/info-section'
import CustomizedTabs from 'admin/components/tabs'
import HeadBar from 'admin/components/head-bar'
import Information from './information'
import OrderHistory from './order-history'
import Wallet from './wallet'

import styles from './styles'

const useStyles = makeStyles(styles)

const EnableSMSNotifyButton = observer(({ prestoId }) => {
  const classes = useStyles()
  const { notificationStore, customerStore } = useStores()
  const { request: updatePOSSmsNotification, isLoading: enableSmsProcessing } = useApiRequest(
    srv.updatePOSSmsNotification,
    { blocking: true },
  )

  const handleSubmit = useCallback(async () => {
    try {
      if (!prestoId) {
        notificationStore.setError('Presto ID is missing.')
        return
      }
      const response = await updatePOSSmsNotification(prestoId)
      if (!response) return

      await customerStore.reload()
      notificationStore.setSuccess('Sms Notification is updated')
    } catch (error) {
      notificationStore.setError(error)
    }
  }, [])

  return (
    <div className={classes.leftMargin}>
      <Button
        variant="contained"
        color="secondary"
        size="small"
        onClick={handleSubmit}
        disabled={enableSmsProcessing}
      >
        Enable SMS Notification
      </Button>
    </div>
  )
})

const CustomerInfo = () => {
  const classes = useStyles()
  const [activeTab, setActiveTab] = useState(0)
  const { infoSectionStore } = useStores()

  const { selected: customer } = infoSectionStore

  const handleChangeTab = useCallback((event, value) => {
    setActiveTab(value)
  }, [])

  const isEnableSMSNotify = useMemo(() => {
    if (!customer) return false
    return (
      customer.paymentProfile.some((paymentProfile) => paymentProfile.status === 'active') &&
      customer.originalData.smsNotification === false
    )
  }, [customer])

  return (
    <InfoSection title="Customer">
      <div className={classes.parentContainer}>
        {customer && (
          <>
            <div className={classes.headbar}>
              <HeadBar
                data={[
                  {
                    label: 'Name',
                    value: customer.name,
                  },
                  {
                    label: 'Phone Number',
                    value: customer.phoneNumber,
                  },
                ]}
              />
              {isEnableSMSNotify && <EnableSMSNotifyButton prestoId={customer.prestoId} />}
            </div>
            <CustomizedTabs
              activeTab={activeTab}
              handleChangeTab={handleChangeTab}
              labels={['Information', 'Order History', 'Wallet']}
            />
            <div className={classes.infoContainer}>
              {activeTab === 0 && <Information key={customer.id} />}
              {activeTab === 1 && <OrderHistory key={customer.id} />}
              {activeTab === 2 && <Wallet key={customer.id} />}
            </div>
          </>
        )}
      </div>
    </InfoSection>
  )
}

export default observer(CustomerInfo)
